function identifyUser() {
  const userEl = document.querySelector("#current-user-info-container");
  if (!userEl) return;

  if (typeof LogRocket !== 'undefined' && LogRocket.identify) {
    LogRocket.identify(userEl.getAttribute("user-id"), {
      name: userEl.getAttribute("name"),
      email: userEl.getAttribute("email"),
    });
  } else {
    setTimeout(identifyUser, 500);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', identifyUser);
} else {
  identifyUser();
}
